export const categories = [
  {
    key: 'plot',
    name: '剧情介绍',
    description:
      '以剧情为核心，逐条梳理《疯狂试爱2》的人物关系、情节线索与结局伏笔，帮助你完整读懂故事的情感逻辑。',
    icon: 'ri-book-open-line',
    subcategories: ['主要角色', '剧情线索', '结局解析'],
  },
  {
    key: 'news',
    name: '资讯报道',
    description:
      '汇集《疯狂试爱2》的最新官方动态、发布会现场与行业观察，第一时间呈现与作品相关的权威资讯。',
    icon: 'ri-newspaper-line',
    subcategories: ['官方发布', '最新动态', '行业观察'],
  },
  {
    key: 'feature',
    name: '花絮专题',
    description:
      '走进《疯狂试爱2》的幕后，收录拍摄纪实、角色特辑与花絮故事，感受镜头之外的真实创作过程。',
    icon: 'ri-film-line',
    subcategories: ['幕后花絮', '角色特辑', '拍摄纪实'],
  },
];